import axios from "axios";

import { CARD_CATEGORY_ADD_ITEM } from "../types";
import ToastManager from "../../../modules/default/popup/alert/apiNotification";
import { CONNECTION_CATEGORY_ADD_ITEM } from "../../constants/connectionConstants";
import { LEAD_CATEGORY_ADD_ITEM } from "../../constants/leadConstants";
import { GALLERY_CATEGORY_ADD_ITEM } from "../../constants/galleryConstant";


// Add new category 
export const handleAddToCategory = (catId, item, categoryType) => (dispatch) => {
    let actionType;
    switch (categoryType) {
        case 'cards':
            actionType = CARD_CATEGORY_ADD_ITEM; 
            break;
        case 'card_connects':
            actionType = CONNECTION_CATEGORY_ADD_ITEM; 
            break;
        case 'prospectors':
            actionType = LEAD_CATEGORY_ADD_ITEM; 
            break;
        case 'files':
            actionType = GALLERY_CATEGORY_ADD_ITEM; 
            break;
        default:
            const errorMessage = 'Invalid category type provided.';
            console.error(errorMessage)
            return;
    }
    dispatch({
        type: actionType,
        payload: {
			catId: catId,
            item: item
        },
    });
};

// Delete category
export const handleCategoryDelete = (id) => async (dispatch) => {
    const toastId = ToastManager.showLoading('Deleting...');
    try {
        const response = await axios.delete('/essential/group', {
           data:{ id: id}
        });
        if (response.status >= 200 && response.status < 300) {
            ToastManager.showSuccess(toastId, response.data.message || 'Group deleted successfully!');
            return response
        }
        
    } catch (err) {
        let errorMsg = Object.values(err.response.data).join(', ')
        ToastManager.showError(toastId, errorMsg || 'Failed to delete group.');
    }
};

// Rename category
export const renameCategoryAction = (id, updatedTitle) => async (dispatch) => {
    const toastId = ToastManager.showLoading('Renaming...');

    try {
      const response = await axios.put('/essential/group', {
        id: id,
        update: {
          title: updatedTitle
        }

      });
      if (response.status >= 200 && response.status < 300) {
        ToastManager.showSuccess(toastId, response.data.message || 'Group renamed successfully!');
        return response;
      }
      
    } catch (err) {
        let errorMsg = Object.values(err.response.data).join(', ')
      ToastManager.showError(toastId, errorMsg || 'Failed to rename group.');
    } 
}

// Add item into category
export const handleAddItem = (id, item, type) => async (dispatch) => {
    // console.log("category id:" + id, "item id:" + item.id, "type:" + type)
    const toastId = ToastManager.showLoading('Processing...');
  try {
    const response = await axios.post('/essential/group/item', {
      groupID: id,
      itemID: item.id,
      itemType: type,
    });

    if (response.status >= 200 && response.status < 300) {
        ToastManager.showSuccess(toastId, response.data.message || 'Item added successfully!');
      return true;
    }
  } catch (err) {
    let errorMsg = Object.values(err.response.data).join(', ')
    ToastManager.showError(toastId, errorMsg || 'Failed to add item.');
  }
};

// Remove category item
export const handleRemoveCategoryItem = (id) => async (dispatch) => {
    const toastId = ToastManager.showLoading('Deleting...');

  try {
    const response = await axios.delete('/essential/group/item', {
        data:{ id: id}
    });

    if (response.status >= 200 && response.status < 300) {
        ToastManager.showSuccess(toastId, response.data.message || 'Item deleted successfully!');
      return true;
    }
  } catch (err) {
    let errorMsg = Object.values(err.response.data).join(', ')
    ToastManager.showError(toastId, errorMsg || 'Failed to delete item.');
  }
};
